import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';

import 'global/multiThemingStyling/multiClientGlobalVariables.scss';
import 'global/style/BaseTenantStyle.sass';

import { getMyDataPath } from 'utils/UrlUtil';

import './DataPolicyPopup.sass';

export const DataPolicyPopup = ({ openSubmitPopup, setOpenSubmitPopup }) => (
  <CustomModal
    isOpen={openSubmitPopup}
    title="Antrag erfolgreich gesendet!"
    content={
      <div className="data-policy-popup__content">
        Ihre Änderung wurde in unserer Datenbank vorgenommen. Vielen Dank für die Aktualisierung.
      </div>
    }
    ctaButtons={
      <ActionButton
        title={<span className="data-policy-popup__cta-button-ok">OK</span>}
        link={getMyDataPath()}
        onClick={() => {
          setOpenSubmitPopup(false);
        }}
        inverted
      />
    }
    aria-labelledby="simple-modal-title"
    aria-describedby="simple-modal-description"
  />
);

DataPolicyPopup.propTypes = {
  openSubmitPopup: PropTypes.bool,
  setOpenSubmitPopup: PropTypes.func,
};
DataPolicyPopup.defaultProps = {
  openSubmitPopup: false,
  setOpenSubmitPopup: () => {},
};
